

export const searchProject=(id,projects)=>{
    const project=projects.find(project => project.id===id)

    return project;
}